import { defineStore } from 'pinia';

interface filter {
  date: string | null;
  status: Array<string> | null;
  category: Array<string> | null;
}

interface Order {
  transaction_id: string | null;
  response: { data: any; error: any | null };
  loader: boolean;
  filter:filter;
}

export const useOrder = defineStore('order', {
  state: (): Order => ({
    transaction_id: null,
    response: { data: null, error: null },
    loader: false,
    filter: {
      date: null,
      status: [],
      category: []
    },
  }),
  actions: {
    setTransactionId(transactionId: string) {
      this.transaction_id = transactionId;
    },
    addFilter(data: filter) {
      this.filter.date = data.date;
      this.filter.status = data.status;
      this.filter.category = data.category;
    },   
    removeFilter() {
      this.filter = {
        date: null,
        status: [],
        category:[],
      };
    },           
    async orderAction(offer: any, serverApiCall: boolean = false) {
      const router = useRouter();
      if (!this.transaction_id) {
        console.error('Transaction ID is required.');
        return;
      }
      
      this.loader = true;
      this.response.data = null;
      this.response.error = null;
      const cart = useCart();
      const OfferStatus = useCheckOffer();
      const firstDeliveryOffer = OfferStatus.delivery?.[0] || {};
      const discountOffer = OfferStatus.discount || [];
      const freebieOffer = OfferStatus.freebie || []
      const slabOffer = OfferStatus.slab || []
      const comboOffer = OfferStatus.combo || []
      let payload = {
        transaction_id: this.transaction_id,
        parent_transaction_id: this.transaction_id
      }
      let offerIds: string[] = [];
        if (
          firstDeliveryOffer.autoApply?.toLowerCase() === "no" &&
          firstDeliveryOffer.percent === 100
        ) {
          offerIds.push(firstDeliveryOffer.id);
        }
        freebieOffer.forEach(f => {
          if (f.autoApply?.toLowerCase() === "no" && f.remainingAmount === 0 && this.items.find(k => k.sku_id === f.sku_id)) {
            offerIds.push(f.id);
          }
        });
        discountOffer.forEach(f => {
          if (f.autoApply?.toLowerCase() === "no" && f.remainingAmount === 0) {
            offerIds.push(f.id);
          }
        });
        slabOffer.forEach(({ slabs }) => {
          slabs.forEach(slab => {
            const { current_qty, minQty, maxQty } = slab;
            const withinRange =
              current_qty >= minQty 
            if (withinRange && slab.autoApply?.toLowerCase() === "no") {
              offerIds.push(slab.id);
            }
          });
        });
        comboOffer.forEach(combo => {
          const itemSkuIds = cart.items.map(item => item.sku_id);
          const allMatched = combo.comboItems.every(sku => itemSkuIds.includes(sku));
        
          if (allMatched && combo.autoApply?.toLowerCase() === "no") {
            offerIds.push(combo.id);
          }
        });
        
        if (offerIds.length) {
          payload.offers = offerIds;
        }

        console.log(JSON.stringify(payload))

      try {

        if (serverApiCall) {
          const { data: orderData, error: orderError } = await useAPIHandler('post', '/orders', {
            body: payload,
            auth: true,
          });
          if (orderData?.rewardStatus === 'failed') {
            throw new Error(orderData?.message ?? 'Reward redemption failed');
          }            
          if (orderError) {
            throw new Error(orderError.message);
          }
        }

        const { data, error } = await useOrderListener(this.transaction_id, offer);
        this.response.data = data;

        const reward = useReward();
        await reward.initialize();

        // --- Handle order confirmation failure ---
        if (error?.message === 'Order confirmation failure') {
          const offerRemovedToast = false;
          cart.clear(offerRemovedToast);
          this.$reset();
          router.push({
            path: '/order-summary',
            query: { transaction_id: this.transaction_id },
          });
        } else if (error) {
          this.response.error = error;
        }
      } catch (error: any) {
        console.error('Error in orderAction:', error.message);
        // Handle order confirmation failure in catch (if thrown from API)
        if (error.message === 'Order confirmation failure') {
          const offerRemovedToast = false;
          cart.clear(offerRemovedToast);
          this.$reset();
          router.push({
            path: '/order-summary',
            query: { transaction_id: this.transaction_id },
          });
        } else {
          this.response.error = error;
        }
      } finally {
        this.loader = false;
      }
    }
  },
  getters: {
    filterCount(state: Order): number {
      let count = 0;
  
      if (state.filter.date) count += 1; 
      count += state.filter.status.length; 
      count += state.filter.category.length; 
  
      return count;
    },
    selectedFilters(state: Order): Object {
      const selectedFilters = state.filter;
      return selectedFilters;
    }, 
  },
  persist: {
    storage: piniaPluginPersistedstate.localStorage()
  }
});
